import { render } from "./AgentDestination.vue?vue&type=template&id=1aa272c4"
import script from "./AgentDestination.vue?vue&type=script&lang=js"
export * from "./AgentDestination.vue?vue&type=script&lang=js"

import "./AgentDestination.vue?vue&type=style&index=0&id=1aa272c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__